import React from "react";
import { useSearchParams } from "react-router-dom";
import Results from "./Results";

// Standalone, no-PrivateRoute page for the AI Scoring Verification
// Wizard's Component A — a real headless Chrome (Puppeteer, server side)
// visits this page to read back GSM's genuine, currently-computed result
// from the real, unmodified Results.jsx dispatcher and whichever real
// format page it renders (IndividualResults.jsx etc.). Never a copy, never
// a reimplementation — this just gets the real app a session to run in.
//
// Auth: mirrors PrintPlayerStats.jsx's pattern exactly — a fresh headless
// browser context has no session, so a short-lived, single-purpose token
// (minted by the wizard backend for exactly this render) is injected into
// sessionStorage synchronously during render, before any child component
// mounts and makes its first api.js call, avoiding any effect-ordering
// race between this wrapper and Results.jsx's own internal data fetch.
export default function PrintWizardResults() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  if (token && sessionStorage.getItem("token") !== token) {
    sessionStorage.setItem("token", token);
  }

  return <Results />;
}
